module.exports = __webpack_public_path__ + "static/media/Live_Inovacao.54672911.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lives/Live_Inovacao.jpeg
// module id = 304
// module chunks = 0